import React, { useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { getDealerProviderSettings, updateDealerProviderSettings } from "../../service/api";
import { dealerproviderDropDownDataLabel } from '../../Utils/appConstants';
import { Box, FormControl, Button } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Loaderpage from "../../pages/LoaderPage";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles({
    adminSettingsContent: {
        textAlign: 'center'
    },
    dropDownData: {
        display: 'flex',
        justifyContent: 'space-between',
        height: '45px'
    },
    item: {
        alignSelf: 'center',
        marginRight: '16px'
    },
    actionButton: {
        display: 'flex',
        marginTop: '16px',
        paddingLeft: '50px',
        flexDirection: 'column'
    },
    dataSettingContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    timePickerElement: {
        width: '100px',
        alignSelf: 'flex-end'
    },
    leftHeading: {
        fontWeight: 700,
        padding: '16px'
    },
    contianer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    dealerProvideSettingContainer: {
        display: 'flex',
        flexDirection: 'row'
    },
    table: {
        minWidth: 550,
    },
    fixedWidthField: {
        width: '80px',
        textAlignLast: 'right'
    }
});

export const DealerInspectorProviderComponent = (props) => {
    const classes = useStyles();
    const [dealerSettingResponse, setDealerSettingResponse] = useState(null);
    const [timezoneSettingResponse,setTimezoneSettingResponse]= useState(null);
    const [auctioncodeSettingResponse,setAuctioncodeSettingResponse]= useState(null);
    const [transportationproviderSettingResponse,setTransportationproviderSettingResponse]= useState(null);
    const [inspectorProviderSettingResponse, setInspectorProviderSettingResponse] = useState(null);
    const [loader, setLoader] = useState(true);
    const [updateDealerSettingError, setUpdateDealerSettingError] = useState(false);
    const [updateDealerSettingSuccess, setUpdateDealerSettingSuccess] = useState(false);
    const [dealerNumberUpdate, setDealerNumberUpdate] = useState('');
    const [timeZone,setTimeZone]= useState('');
    const [auctionCode,setAuctionCode]= useState('');
    const [transportationProvider,setTransportationProvider]= useState('');
    const [inspecterProvider, setInspecterProvider] = useState('');

    useEffect(async () => {
        setLoader(true);
        const dealerProviderSettings = await getDealerProviderSettings();
        if (dealerProviderSettings?.data && dealerProviderSettings?.status === 200) {
            setDealerSettingResponse(dealerProviderSettings?.data?.dealerDefaults);
            setInspectorProviderSettingResponse(dealerProviderSettings?.data?.inspectionProviders);
            setTimezoneSettingResponse(dealerProviderSettings?.data?.timeZones)
            setAuctioncodeSettingResponse(dealerProviderSettings?.data?.auctionCodes);
            setTransportationproviderSettingResponse(dealerProviderSettings?.data?.transportationProviders);
        }
        setLoader(false);
    }, []);

    const updateDealerProviderSettingResponse = () => {
        setDealerNumberUpdate('');
        setInspecterProvider('');
        setTimeZone('');
        setAuctionCode('');
        setTransportationProvider('');
        setTimeout(() => { setLoader(false) }, 200);
    }

    const handleDealerInspectorProviderSelectChange = (event, index) => {
        if (index === 0) {
            setLoader(true)
            const currentData = dealerSettingResponse.filter((elm, i) => elm?.dealerName === event?.target?.value);
            setInspecterProvider(currentData[0]?.inspectionProvider)
            setDealerNumberUpdate(currentData[0]);
            setTimeZone(currentData[0]?.timeZone);
            setAuctionCode(currentData[0]?.defaAauctionCode);
            setTransportationProvider(currentData[0]?.defaTransportationProvider);
            setTimeout(() => { setLoader(false) }, 100);
        } 
        else if(index===1){
            return setInspecterProvider(event?.target?.value);
        }
        else if(index===2){
            return setTimeZone(event?.target?.value);
        }
        else if(index===3){
            return setAuctionCode(event?.target?.value);
        }
        else if(index===4){
            return setTransportationProvider(event?.target?.value);
        }
    };

    const updateDealerSetting = async () => {
        const body = {
            dealerNumber: dealerNumberUpdate?.dealerNumber,
            inspectionProvider: inspecterProvider,
            timeZone: timeZone,
            auctionCode: auctionCode,
            transportationProvider: transportationProvider
        };
        setLoader(true);
        const updatedAdminSettingValue = await updateDealerProviderSettings(body);
        if (updatedAdminSettingValue?.status === 200) {
            setLoader(false);
            setUpdateDealerSettingError(false);
            setUpdateDealerSettingSuccess(true);
        } else {
            setLoader(false);
            setUpdateDealerSettingSuccess(false);
            setUpdateDealerSettingError(true);
        }
    }

    const resetDealerSetting = () => {
        setLoader(true);
        updateDealerProviderSettingResponse();
    }

    return (
        <div >
            <div className='bottomPanelDealerProvideSetting'>
                <div className={classes.leftHeading}>Dealer Defaults:</div>
                {!loader && <div className={classes.contianer}><div className={classes.dealerProvideSettingContainer}>
                    <TableContainer >
                        <Table className={classes.table} aria-label="simple table">
                            <TableBody className={classes.cellBorder}>
                                {dealerproviderDropDownDataLabel.map((item, index) => {
                                    // const currentData = index === 0 ? dealerSettingResponse : inspectorProviderSettingResponse;
                                    let Responselist= [dealerSettingResponse,inspectorProviderSettingResponse,timezoneSettingResponse,auctioncodeSettingResponse,transportationproviderSettingResponse];
                                    let ReponselistValue = [dealerNumberUpdate?.dealerName , inspecterProvider , timeZone , auctionCode , transportationProvider]
                                    const currentData=Responselist[index];
                                    return (<TableRow key={index}>
                                        <TableCell className={classes.cellBorder} component="th" scope="row">
                                            {item}
                                        </TableCell>
                                        <TableCell className={classes.cellBorder} align="right">
                                            <FormControl>
                                                <Select
                                                    labelId="demo-customized-select-label"
                                                    id="demo-customized-select"
                                                    onChange={(e) => handleDealerInspectorProviderSelectChange(e, index)}
                                                    defaultValue={ReponselistValue[index]}
                                                >
                                                    {/* {index === 1 && <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>} */}
                                                    {currentData &&
                                                        currentData.map((menuitem, i) => {
                                                            return (
                                                                <MenuItem key={i} value={index === 0 ? menuitem?.dealerName : menuitem}>
                                                                    {" "}
                                                                    {index === 0 ? menuitem?.dealerName : menuitem}
                                                                </MenuItem>
                                                            )
                                                        }
                                                        )}
                                                </Select>
                                            </FormControl>
                                        </TableCell>
                                    </TableRow>)
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                    <div className={classes.actionButton}>
                        {updateDealerSettingError && !updateDealerSettingSuccess && <><div style={{ color: 'red' }}>Please adjust the Dealer Settings.</div> <br /></>}
                        {updateDealerSettingSuccess && !updateDealerSettingError && <><div style={{ color: '#00C6B7' }}>Successfully Updated the Dealer Settings.</div> <br /></>}
                        <Box display={'flex'}
                            sx={{
                                "& .MuiButton-root": {
                                    m: 5
                                }
                            }}>
                            <div style={{ paddingRight: '16px' }}>
                                <Button
                                    className={`passButton ${classes.buttonHandle}`}
                                    color="primary"
                                    onClick={() => resetDealerSetting()}
                                >
                                    Cancel
                                </Button>
                            </div>
                            <div>
                                <Button
                                    className={`purchaseButton ${classes.buttonHandle}`}
                                    color="primary"
                                    onClick={() => updateDealerSetting()}
                                >
                                    Submit
                                </Button>
                            </div>
                        </Box>

                    </div></div>}
            </div>
            <div>
                {loader ? (
                    <Box
                        height={"350px"}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                    >
                        <div>
                            <Loaderpage />
                            <span className="loaderText">Loading...</span>
                        </div>
                    </Box>
                ) : (
                    ""
                )}
            </div>
        </div>
    );
};

export default DealerInspectorProviderComponent;